import axios from 'axios';
import { BaseUrl } from '../../server';

export const getAllServices = (page , limit ) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_all_services_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/services`, {
            params: {
                page,
                limit,
            },
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_all_services_success',
            payload: {
                services: data.services,
                pagination: data.pagination, 
                totalServices:data.totalServices// معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_all_services_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};

export const getFillterServices = (page , limit,titleAr,titleEn) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_services_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/services/filter`, {
            params: {
                page,
                limit,
                titleAr,
                titleEn,
            },
            withCredentials: true,
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_Fillter_services_success',
            payload: {
                services: data.services,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_Fillter_services_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};




export const getServices = (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_services_request' });

        const { data } = await axios.get(`${BaseUrl}/services/${id}`);
        console.log("data",data);
        dispatch({ type: 'get_services_success' ,payload:data.service});

    } catch (error) {
        dispatch({
            type: "get_services_error",
            payload: error.response.data.message,
          });
    }
}